export var breakpoints = {
    mobile: 0,
    tablet: "47.93rem",
    desktop: "64rem",
    bigDesktop: "82rem",
    largeDesktop: "90rem"
};
